import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireAvia_fw } from "/home/runner/_work/vtg-avia-js/vtg-avia-js/libs/plugins/fw/dist/avia.fw.cjs";
var avia_fwExports = requireAvia_fw();
export { avia_fwExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(avia_fwExports);